import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginRouting } from './login-routing.module';
import { LoginComponent } from './login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { EkeyLoginComponent } from './intgration/ekey-login/ekey-login.component';
import { EkeyRedirectPageComponent } from './intgration/ekey-redirect-page/ekey-redirect-page.component';
import { EmailLoginComponent } from './email-login/email-login.component';
import { EmailLoginIntegrationComponent } from './email-login-integration/email-login-integration.component';
import {EmailActivation} from "./email-activation/email-activation.component";
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { CommonService } from '../shared/services/common.service';
import { IRegisterUser } from '../shared/interfaces/IRegisterUser';
import { EKeyIntegrationLoginComponent } from './ekey-integration-login/ekey-integration-login.component';

@NgModule({
  imports: [
    CommonModule,
    LoginRouting,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
   // CommonService,
    
  ],
  declarations: [
      LoginComponent,
      EkeyLoginComponent,
      EkeyRedirectPageComponent,
      EmailLoginComponent,
      EmailLoginIntegrationComponent,
      EmailActivation,
      ForgotPasswordComponent,
      ResetPasswordComponent,
      EKeyIntegrationLoginComponent,
  ],
  exports: [
    EKeyIntegrationLoginComponent // only if used outside this module
  ]
})
export class LoginModule { }
